import {
  createSlice,
  createSelector,
  createAction,
  PayloadAction,
} from '@reduxjs/toolkit';

import { RootState } from 'src/redux/store';
import { DATA_FETCHING_STATUS, DATA_STATE_KEY } from '../../constants';
import { ResponseInterface } from '../../types';
import { EmrFrequencySettingType } from 'src/routes/Customers/components/OperatorsTab/modules/types';
import { parseEmrSchedullingFrequencyResponse } from './utils';

export const STATE_KEY = 'emrSchedullingFrequency';

export const INITIAL_STATE: {
  emrSchedullingFrequency: ResponseInterface<EmrFrequencySettingType>;
  emrSchendullingStatus: keyof typeof DATA_FETCHING_STATUS | null;
} = {
  emrSchedullingFrequency: { data: null, status: null },
  emrSchendullingStatus: null,
};

const slice = createSlice({
  name: STATE_KEY,
  initialState: INITIAL_STATE,
  reducers: {
    setEmrSchedullingFrequncy(
      state,
      action: PayloadAction<EmrFrequencySettingType>,
    ) {
      state.emrSchedullingFrequency.data = parseEmrSchedullingFrequencyResponse(
        action.payload,
      );
    },
    setGetEmrSchedullingFrequncyStatus(
      state,
      action: PayloadAction<keyof typeof DATA_FETCHING_STATUS>,
    ) {
      state.emrSchedullingFrequency.status = action.payload;
    },
    setEmrSchedullingFrequncyStatus(
      state,
      action: PayloadAction<keyof typeof DATA_FETCHING_STATUS>,
    ) {
      state.emrSchedullingFrequency.status = action.payload;
    },
  },
});

export const getState = (state: RootState) =>
  state[DATA_STATE_KEY][STATE_KEY] || INITIAL_STATE;

export const selectors = {
  selectEmrSchedullingFrequency: createSelector(
    getState,
    state => state.emrSchedullingFrequency.data,
  ),
  selectEmrSchedullingFrequencyStatus: createSelector(
    getState,
    state => state.emrSchedullingFrequency.status,
  ),
};

const extraActions = {
  getEmrSchedullingFrequncyByOperatorId: createAction(
    `${STATE_KEY}/getEmrSchedullingFrequncyByOperatorId`,
  ),
  createEmrSchedullingFrequncyByOperatorId:
    createAction<EmrFrequencySettingType>(
      `${STATE_KEY}/createEmrSchedullingFrequncyByOperatorId`,
    ),
  editEmrSchedullingFrequncyByOperatorId: createAction<EmrFrequencySettingType>(
    `${STATE_KEY}/editEmrSchedullingFrequncyByOperatorId`,
  ),
};

export const actions = { ...slice.actions, ...extraActions };

const { reducer } = slice;
export default reducer;
